// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
export enum NotificationOptions {
  NoAction = 'no action',
  Action = 'action',
  ViewMore = 'view more',
}
